module.exports = {
    '3D_PRODUCT_NAME': 'Data Driven Display',
    RT_PRODUCT_NAME: 'Retargeting',
    DATE_STRING_FORMAT: 'MM/DD/YYYY'
};
